export default __webpack_public_path__ + "static/media/environment-icon.86c3917c.svg";